'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_patterns_ServiceIconShell_ServiceIconShell = require('../ServiceIconShell/ServiceIconShell.cjs.js');
const components_display_Img_Img = require('../../display/Img/Img.cjs.js');
const components_patterns_ServiceIcon_constants = require('./constants.cjs.js');

const ServiceIcon = ({ alt, "aria-hidden": ariaHidden = false, hasBorder = true, hasShadow = false, hasWhiteBackground = false, serviceName, size, src }) => {
  const iconSize = components_patterns_ServiceIcon_constants.ServiceIconConfig[size].iconSize;
  return react.jsx(
    components_patterns_ServiceIconShell_ServiceIconShell.ServiceIconShell,
    { hasBorder, hasShadow, hasWhiteBackground, size },
    react.jsx(components_display_Img_Img.Img, { alt: alt || `${serviceName} logo`, "aria-hidden": ariaHidden, borderRadius: "none", height: iconSize, width: iconSize, objectFit: "contain", src })
  );
};

exports.ServiceIcon = ServiceIcon;
//# sourceMappingURL=ServiceIcon.cjs.js.map
